import React from "react";
import {useTranslation} from "react-i18next";

const TimerBlock: React.FC<{timeLeft: number, onCheckout: () => void, disabled?: boolean }> = ({timeLeft, onCheckout, disabled}) => {
    const { t } = useTranslation();
    const minutes = String(Math.floor(timeLeft / 60)).padStart(2, '0');
    const seconds = String(timeLeft % 60).padStart(2, '0');
    return (
        <div className="subscription-detail__timer-row">
            <div className="subscription-detail__timer-block">
                <div className="subscription-detail__timer-label">{t('subscription.startLearningNow')}</div>
                <div className="subscription-detail__timer-value">
                    <div style={{ flexDirection: 'column'}}>
                        <div className="subscription-detail__timer-minutes">{minutes}</div>
                        <div className="subscription-detail__timer-units">
                            <span>{t('subscription.min')}</span>
                        </div>
                    </div>
                    <span className="subscription-detail__timer-colon">:</span>
                    <div>
                        <div className="subscription-detail__timer-seconds">{seconds}</div>
                        <div className="subscription-detail__timer-units">
                            <span>{t('subscription.sec')}</span>
                        </div>
                    </div>
                </div>
            </div>
            <button
                className="subscription-detail__timer-btn"
                onClick={onCheckout}
                disabled={disabled}
                tabIndex={0}
                aria-label={t('subscription.getMyPlan')}
                onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') onCheckout(); }}
            >
                {t('subscription.getMyPlan')}
            </button>
        </div>
    );
};

export default TimerBlock;
